export default "<mat-toolbar color=\"primary\">\n  <mat-toolbar-row>\n    <h1>Save For House</h1>\n  </mat-toolbar-row>\n</mat-toolbar>\n"